import isEqual from 'react-fast-compare';

import * as analytics from 'analytics/Analytics';
import {WORKFLOWS_ANALYTICS_ACTIONS} from 'constants/analytics-products';
import {ActionOrigin} from 'constants/AnalyticsConstants';

import {ProcessFlowchartValidationError} from './ProcessFlowchartForValidationTypes';

/**
 * Extract the current errors that were not in the previous errors list.
 * This is used to track only "new" validation errors for analytics purposes,
 * avoiding noise from errors that persist across multiple validation runs.
 */
export function findNewProcessFlowchartValidationErrors(
  previousValidationErrors: Array<ProcessFlowchartValidationError>,
  currentValidationErrors: Array<ProcessFlowchartValidationError>
): Array<ProcessFlowchartValidationError> {
  return currentValidationErrors.filter(
    (error) => previousValidationErrors.find((e) => isEqual(error, e)) == null
  );
}

interface TrackValidationErrorOptions {
  flowchartConfigId: string;
  actionOrigin: ActionOrigin;
}

/**
 * Tracks analytics events for newly triggered validation errors.
 * This should only be called with errors that are "new" - i.e., not present
 * in the previous validation run.
 */
export function trackTriggeredFlowchartValidationError(
  newValidationErrors: Array<ProcessFlowchartValidationError>,
  options: TrackValidationErrorOptions
): void {
  for (const validationError of newValidationErrors) {
    analytics.trackEvent(WORKFLOWS_ANALYTICS_ACTIONS.TRIGGERED_FLOWCHART_VALIDATION_ERROR, {
      actionOrigin: options.actionOrigin,
      flowchartConfigId: options.flowchartConfigId,
      objectId: validationError.object?.id ?? null,
      objectType: validationError.object?.type ?? null,
      parentObjectIds: validationError.parentObjects?.map((parentObject) => parentObject.id) ?? null,
      parentObjectTypes: validationError.parentObjects?.map((parentObject) => parentObject.type) ?? null,
      validationError: validationError.errorMessage,
      validationErrorType: validationError.errorType,
      blocksPersistence: validationError.blocksPersistence,
    });
  }
}
